import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconWarningSignOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 33 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="m16 4 .18.1L29.98 28v.2l-.18.1H2.2l-.18-.1V28l13.8-23.9zm0-2c-.74 0-1.48.36-1.9 1.1L.3 27c-.84 1.46.22 3.3 1.9 3.3h27.6c1.7 0 2.76-1.84 1.9-3.3L17.9 3.1C17.48 2.36 16.74 2 16 2" /><path fill="currentColor" d="M16 26.32a1.3 1.3 0 1 0 0-2.6 1.3 1.3 0 0 0 0 2.6m0-15.64c-.56 0-1 .44-1 1v9.1c0 .56.44 1 1 1s1-.44 1-1v-9.1c0-.56-.44-1-1-1" /></svg>;
export default SvgIconWarningSignOutlined;